<div [ngStyle]="{ background: 'url(assets/images/MARSBanner.png)' }" class="content-header">
  <h2 class="header-title">Version History</h2>
</div>
<div class="version-history">
  <div class="wrapper">
    <markdown  [data]="versionHistoryList"> </markdown>
  </div>
</div>